<template>
  <b-container fluid>
    <b-row style="margin-top: 5em">
      <b-col>
        <b-tabs lazy>
          <b-tab title="Admin:" disabled></b-tab>
          <!-- TODO
          <b-tab :title="$t('globals.permissions')" active>
            
          </b-tab>-->
          <b-tab title="Enumerators">
            <ulu-enums-tab />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-enums-tab": () =>
      import("@/components/admin/enums/AllEnums")
  },
  data() {
    return {

    };
  },
  methods: {
    
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  created() {
    if (!this.getUserBrandPermissions.super_admin) {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>
